import React from "react";
import Typography from "@material-ui/core/Typography";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { useStyles } from "./style";

export const StatusCompleted = () => {
  const classes = useStyles();
  return (
    <Typography variant="h6" className={classes.subStatus}>
      <i className={classes.iconClass}>
        <CheckCircleIcon className={classes.insideIcon} />
        <span className={classes.insideStatus}>Completed</span>
      </i>
    </Typography>
  );
};
export const StatusPending = () => {
  const classes = useStyles();
  return (
    <Typography variant="h6" className={`${classes.subStatus} ${classes.subStatusPending}`}>
      <i className={classes.iconClass}>
        <RemoveCircleIcon className={classes.insideIcon} />
        <span className={classes.insideStatus}>Pending</span>
      </i>
    </Typography>
  );
};
export const StatusCancel = (props: any) => {
  const classes = useStyles();

  return (
    <Typography variant="h6" className={`${classes.subStatus} ${classes.subStatusCancel}`}>
      <i className={classes.iconClass}>
        <CancelIcon className={classes.insideIcon} />
        <span className={classes.insideStatus}>{props.title}</span>
      </i>
    </Typography>
  );
};
